import { request } from "../utils/request";

const examApi = {
  //修改考试时间
  updateExamTime(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/examApi/updateExamTime",
      data
    });
  },
  //---------------------------------------------------------------------------------------->>>>>
  // 练习监控列表
  getList(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/getList",
      data
    });
  },
  exerciseStudent(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/exerciseManage/exerciseStudent",
      data
    });
  },
  // 个人练习情况下拉查询
  getseekAndCreateExam(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/seekAndCreateExam",
      data
    });
  },
  // 练习监控 练习列表
  practiceData(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/practiceData",
      data
    });
  },
  // 练习监控 获取练习数据 个体练习情况列表
  studentsDataList(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/studentsDataList",
      data
    });
  },
  // 练习监控 获取详细做题记录
  stuLogDetail(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/stuLogDetail",
      data
    });
  },
  // chang查询
  getStuListSearchItems(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/getStuListSearchItems",
      data
    });
  },
  // 每日练习 
  practiceSituation(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/practiceSituation",
      data
    });
  },
  // 每日练习 导出Excel
  exportPracticeSituation(data) {
    return request({
      method: "POST",
      url: "/api/exammanage/practiceControl/exportPracticeSituation",
      data,
      responseType: "blob"
    });
  },
};

export default examApi;
